import React, { useEffect, useState } from 'react';
import api from '../services/api';

const BANNER_STYLE = {
  position:        'sticky',
  top:             0,
  zIndex:          10000,
  width:           '100%',
  background:      'linear-gradient(90deg, #7c1a1a 0%, #b91c1c 50%, #7c1a1a 100%)',
  color:           '#fff',
  textAlign:       'center',
  padding:         '10px 16px',
  fontSize:        14,
  fontWeight:      700,
  letterSpacing:   0.3,
  boxShadow:       '0 3px 12px rgba(185,28,28,0.6)',
  borderBottom:    '2px solid #ef4444',
  userSelect:      'none',
};

export default function TestModeBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    api.get('/payments/gateways')
      .then(r => { if (r.data?.dummyActive) setShow(true); })
      .catch(() => {});
  }, []);

  if (!show) return null;

  return (
    <div style={BANNER_STYLE} role="alert" aria-live="assertive">
      🧪 TEST MODE — Payments are simulated, no real charges
    </div>
  );
}
